//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import messageBox from '@/components/messageBox';
export default {
  components: { messageBox },
  props: {
    status: {
      type: String,
      default: '',
    },
    jurisdiction: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      list: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.$request({
        url: this.$api.getProcessActionList,
        data: {
          page: this.pageIndex,
          size: this.pageSize,
          input_params: {
            status: this.status,
            category: '2',
          },
        },
        cb: ({ list, total }) => {
          if (list?.length) {
            this.list = list
              .filter((item) => item.category === 2)
              .map((obj) => ({
                ...obj,
                func_name: obj.template?.cloud_func?.name,
              }));
          } else {
            this.list = [];
          }
          this.total = Number(total);
        },
      });
    },
    goEdit({ id }) {
      this.$router.push({
        name: 'cloud-event-detail',
        query: {
          id,
          eventTypes: 'cloudEvent',
          statusTab: this.status,
        },
      });
    },
    del({ id }) {
      this.$refs.messageBox.show({
        title: '提示',
        content: '确定删除该数据吗?',
        titleIconType: 'warning',
        exitButton: true,
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.$request({
            url: this.$api.deleteProcessAction,
            data: { id },
            cb: () => {
              this.$refs.messageBox.close();
              this.pageIndex = 1;
              this.getList();
            },
          });
        },
      });
    },
    // 启用/禁用
    changeStatus({ id }, status) {
      // 接口名
      let api;
      switch (status) {
        case '1':
          api = this.$api.enableProcessAction;
          break;
        case '2':
          api = this.$api.disableProcessAction;
          break;
      }
      if (!api) return;
      this.$request({
        url: api,
        data: { id },
        cb: () => {
          this.pageIndex = 1;
          this.getList();
        },
      });
    },
    // 分页器
    handleSizeChange(value) {
      this.pageIndex = 1;
      this.pageSize = value;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
  },
};
